import { render, staticRenderFns } from "./SalesOrderViewDetailsSalesOrderItemTable.vue?vue&type=template&id=5988179c"
import script from "./SalesOrderViewDetailsSalesOrderItemTable.vue?vue&type=script&lang=js"
export * from "./SalesOrderViewDetailsSalesOrderItemTable.vue?vue&type=script&lang=js"
import style0 from "./SalesOrderViewDetailsSalesOrderItemTable.vue?vue&type=style&index=0&id=5988179c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports